import {useCallback} from 'react';
import {store, useAppDispatch} from '../../../redux';
import {blockReissueIfAlreadySubmitted} from '../../../redux/actions/cardReissue';
import {getHolderProfile} from '../../../redux/actions/profile';
import {loginSlice} from '../../../redux/reducers/login';
import {addNotification} from '../../../redux/actions/snackbar';
import {SnackbarNotificationType} from '../../../shared/components/snackbar/model';
import {holderProfileSelector} from '../../../redux/selectors/profile';
import {AuthorizeEsiaResponsePayload} from '../../../shared/models/api/authorizeEsiaResponsePayload';
import {GetHolderProfileCabinetResponsePayload} from '../../../shared/models/api';
import {mapHolderProfileToEsiaRegInfo} from '../../login/esiaRegCard/components/formMapper';

type Params = {
  holderProfile: GetHolderProfileCabinetResponsePayload | null;
  hideAndLockGlobalLoader: () => void;
  unlockGlobalLoader: () => void;
  showGlobalLoader: () => void;
  openForm: (readOnly?: boolean) => void;
  prepareRegCardState: (regInfo: AuthorizeEsiaResponsePayload) => void;
  setSubmitting: (value: boolean) => void;
};

export const useReissueContinue = ({
  holderProfile,
  hideAndLockGlobalLoader,
  unlockGlobalLoader,
  showGlobalLoader,
  openForm,
  prepareRegCardState,
  setSubmitting,
}: Params) => {
  const dispatch = useAppDispatch();

  const onContinue = useCallback(async () => {
    if (await dispatch(blockReissueIfAlreadySubmitted())) {
      return;
    }

    setSubmitting(true);
    unlockGlobalLoader();
    showGlobalLoader();
    try {
      if (!holderProfile) {
        await dispatch(getHolderProfile());
      }
      const holder = holderProfileSelector()(store.getState());
      if (!holder) {
        throw new Error('Holder profile is unavailable');
      }

      const regInfo = mapHolderProfileToEsiaRegInfo(holder);
      prepareRegCardState(regInfo);
      dispatch(loginSlice.actions.setEsiaRegistrationInfo(regInfo));
      openForm(true);
    } catch {
      hideAndLockGlobalLoader();
      dispatch(
        addNotification({
          message: 'Не удалось загрузить данные держателя карты. Попробуйте ещё раз.',
          type: SnackbarNotificationType.Error,
        }),
      );
    } finally {
      setSubmitting(false);
    }
  }, [
    hideAndLockGlobalLoader,
    dispatch,
    holderProfile,
    openForm,
    prepareRegCardState,
    setSubmitting,
    unlockGlobalLoader,
    showGlobalLoader,
  ]);

  return {onContinue};
};
